<template>
<CDropdown v-if="!isMobile"
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
    :show.sync="isShowLoginInfo"
    >
    <template #toggler>
      <CHeaderNavLink>
        <!-- <div class="c-avatar round"> -->
        <avatar
          class="c-avatar-img square"
          :username="getUserName"
          :size="40"
          color="#fff"
        ></avatar>
        <!--          <img-->
        <!--            src="img/avatars/5.jpg"-->
        <!--            class="c-avatar-img round"-->
        <!--            width="60"-->
        <!--            height="60"-->
        <!--          />-->
        <!--            class="c-avatar-img round"-->
        <!-- <img
                            src="https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/gettyimages-168889366-1572948662.jpg?crop=0.668xw:1.00xh;0.105xw,0&resize=480:*"
                            class="c-avatar-img square"
                            width="80"
                            height="80"
                    /> -->
        <!-- </div> -->
      </CHeaderNavLink>
    </template>
    <!-- <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>Account</strong>
        </CDropdownHeader>
        <CDropdownItem>
            <CIcon name="cil-bell" /> Updates
            <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-envelope-open" /> Messages
            <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-task" /> Tasks
            <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-comment-square" /> Comments
            <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>-->

    <div>
      <!--
          <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>Settings</strong>
          </CDropdownHeader>
          <CDropdownItem> <CIcon name="cil-user" />Profile </CDropdownItem>
          <CDropdownItem> <CIcon name="cil-settings" />Settings </CDropdownItem> -->
<cUserInfo v-if="isShowLoginInfo"></cUserInfo>
      <!-- <CDropdownHeader tag="div" class="text-center" style="padding: 0px;">
        <div class="profile-drop-wrap">
          <div class="head" v-if="userLogoDet.logoDet">
            <div class="profile">
              <avatar
                class="c-avatar-img square"
                :username="getUserName"
                :size="80"
                color="#fff"
              ></avatar>
              
            </div>
            <div class="details">
              <div class="name">{{ getUserName }}</div>
              <div
                class="profile-t-tag"
                v-if="
                  userLogoDet.logoDet.roles &&
                    userLogoDet.logoDet.roles.length > 0
                "
              >
                <div
                  class="role"
                  v-for="(role, index) in userLogoDet.logoDet.roles"
                  :key="'r' + index"
                >
                  <div>{{ role }}</div>
                </div>
              </div>
              
              <div class="email" v-if="userLogoDet.logoDet.agencyname">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  class="c-icon c-icon-custom-size"
                  height="42"
                >
                  <path
                    d="M19.294 16.109l-3.414-2.219 1.287-2.359c0.288-0.519 0.457-1.137 0.458-1.796v-3.735c0-2.9-2.351-5.25-5.25-5.25s-5.25 2.351-5.25 5.25v0 3.735c0.001 0.658 0.17 1.277 0.468 1.815l-0.010-0.019 1.287 2.359-3.414 2.219c-1.033 0.676-1.706 1.828-1.706 3.137 0 0.002 0 0.005 0 0.007v-0 3.997h17.25v-3.997c0-0.002 0-0.005 0-0.007 0-1.309-0.673-2.461-1.692-3.128l-0.014-0.009zM19.5 21.75h-14.25v-2.497c0-0.001 0-0.003 0-0.004 0-0.785 0.404-1.477 1.015-1.877l0.009-0.005 4.578-2.976-1.952-3.578c-0.173-0.311-0.274-0.682-0.275-1.077v-3.735c0-2.071 1.679-3.75 3.75-3.75s3.75 1.679 3.75 3.75v0 3.735c-0 0.395-0.102 0.766-0.281 1.089l0.006-0.012-1.952 3.579 4.578 2.976c0.62 0.406 1.024 1.097 1.024 1.882 0 0.001 0 0.003 0 0.004v-0z"
                  ></path>
                </svg>
                <div v-if="userLogoDet.logoDet.agencyname">
                  {{ userLogoDet.logoDet.agencyname }}
                </div>
              </div>
              <div class="address" v-if="userLogoDet.logoDet.email">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  role="img"
                  class="c-icon c-icon-custom-size"
                  height="42"
                >
                  <path
                    d="M12.872 1.201c-0.242-0.175-0.545-0.279-0.872-0.279s-0.63 0.105-0.876 0.282l0.004-0.003-10.378 7.413v14.636h22.5v-14.636zM21.75 18.876l-5.814-3.737 5.814-4.522zM12 2.422l9.301 6.644-6.703 5.213-2.598-1.67-2.598 1.67-6.703-5.213zM2.25 10.617l5.814 4.522-5.814 3.737zM21.75 21.75h-19.5v-1.091l9.75-6.268 9.75 6.268z"
                  ></path>
                </svg>
                <div v-if="userLogoDet.logoDet.email">
                  {{ userLogoDet.logoDet.email }}
                </div>
              </div>
              
            </div>
          </div>

          <div class="body">
            <cLoginInfo
              v-if="isShowLoginInfo"
              @showAlert="showAlert"
            ></cLoginInfo>
          </div>
          <div class="foot">
            <div class="d-flex w-100">
              <div class="lan-drop">
                <cLanguagePicker
                  v-model="language"
                  ctrlName="en_name"
                  :isShowCode="true"
                  :isMultiple="false"
                  :isSearchable="true"
                  :url="languageListURL"
                  rules="_required"
                  :selValue="language"
                />
              </div>
              <div class="logout" @click="onLogout">
                <div class="d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    role="img"
                    class="c-icon c-icon-custom-size"
                    height="42"
                  >
                    <path
                      d="M18 9.375v-2.625c0-3.314-2.686-6-6-6s-6 2.686-6 6v0 2.625h-1.875v6c0 4.342 3.533 7.875 7.875 7.875s7.875-3.533 7.875-7.875v-6zM7.5 6.75c0-2.485 2.015-4.5 4.5-4.5s4.5 2.015 4.5 4.5v0 2.625h-9zM18.375 15.375c0 3.515-2.86 6.375-6.375 6.375s-6.375-2.86-6.375-6.375v-4.5h12.75z"
                    ></path>
                  </svg>
                  <div>Logout</div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </CDropdownHeader> -->
      <!--      <CDropdownDivider v-if="userLogoDet.agencyname" />-->
      <!--      <CDropdownItem-->
      <!--        v-if="userLogoDet.agencyname"-->
      <!--        class="d-flex justify-content-center"-->
      <!--      >-->
      <!--        <span class="text-center">-->
      <!--          {{ userLogoDet.agencyname }}-->
      <!--        </span></CDropdownItem-->
      <!--      >-->
      <!--      <CDropdownDivider v-if="userLogoDet.agencyname" />-->

      <!--      <CDropdownItem v-if="userLogoDet.agenttype">-->
      <!--        <div>-->
      <!--          <strong>{{ balance[userLogoDet.agenttype] }}</strong>-->
      <!--        </div>-->
      <!--      </CDropdownItem>-->
      <!--      <CDropdownItem v-if="userLogoDet.b2bCompanyFinancess">-->
      <!--        <div-->
      <!--          v-for="(finance, index) in userLogoDet.b2bCompanyFinancess"-->
      <!--          :key="index"-->
      <!--        >-->
      <!--          <CButton @click="viewBalance(finance)">-->
      <!--            <span>-->
      <!--              {{ finance.currencycode.code }}-->
      <!--              {{ finance.currencycode.symbol }}-->
      <!--              {{ finance.postpaidlimit }}-->
      <!--            </span>-->
      <!--          </CButton>-->
      <!--        </div>-->
      <!--      </CDropdownItem>-->
      <!--      <CDropdownDivider v-if="userLogoDet.agencyname" />-->
      <!-- <CDropdownItem>
              <CIcon name="cil-dollar" /> Payments
              <CBadge color="secondary" class="ml-auto">{{ itemsCount }}</CBadge>
          </CDropdownItem>
          <CDropdownItem>
              <CIcon name="cil-file" /> Projects
              <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
          </CDropdownItem>-->

      <!-- <CDropdownItem>

              <CIcon name="cil-shield-alt" /> Lock Account
          </CDropdownItem>-->
      <!--      <CDropdownItem>-->
      <!--        <CButton @click="onLogout">-->
      <!--          <CIcon name="cil-lock-locked" />Logout-->
      <!--        </CButton>-->
      <!--      </CDropdownItem>-->
  <CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>    </div>
  </CDropdown>
  <div v-else-if="isMobile" @click="navigateIfMbl()">
    
        <avatar v-if="currentRouteName!='aProfile'"
          class="c-avatar-img square"
          :username="getUserName"
          :size="40"
          color="#fff"
        ></avatar>
        </div>
</template>
<script>
import cLanguagePicker from "./../components/cLanguagePicker";
import cUserInfo from "./../components/userinfo/cUserInfo"
import { mapActions, mapGetters } from "vuex";
import { handleJWT, getErrorAlertValue } from "./../util/util";
import { PATHNAME, COMPONENT_NAME, APPROVEAGENT } from "../util/constants";
// import apiUserLogoDet from "./../services/apiUserLogoDet";
import Logger from "./../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "./../config/API_DATA";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "./../util/apiValidate";
import apiLogOut from "./../services/apiLogOut";

import router, { navigate, goBack } from "./../router/index";
import store from "../store";
//import apiGetBalanceDetail from "./../services/apiGetBalanceDetail";
import BaseConfiguration from "./../config/base";
import cLoginInfo from "./../components/cLoginInfo";
//import Avatar from "vue-avatar-component";
import Avatar from 'vue-avatar'
import { clearStore } from "./../store/clearStore";
import { removeB2BMFfromSession } from "./../applocalstorage/localStorage";
export default {
  name: "TheHeaderDropdownAccnt",
  components: {
    cLanguagePicker,
    cLoginInfo,
    cUserInfo,
    //avatar
    Avatar
  },
  data() {
    return {
      isMobile: BaseConfiguration.isMobile,
      language: [
        {
          langcode: null,
          en_name: null,
          native_name: null
        }
      ],
      languageListURL: SERVICE_URL.LANGUAGE_LIST,
      itemsCount: 42,
      balance: {
        1: "PrePaid",
        2: "PostPaid"
      },
      alertValue: null,
      isShowLoginInfo: false,
      userLogoDet: null,
      // userLogoDet: {
      //     firstname: null,
      //     lastname: null,
      //     agencyname: null,
      //     b2bCompanyFinancess: []
      // }
      userLogoDet: {
        logoDet: null
        // b2bCompanyFinancess: []
      }
      // agentType: {
      //     prepaid: APPROVEAGENT.PREPAID,
      //     postpaid: APPROVEAGENT.POSTPAID
      // }
    };
  },
  methods: {
    ...mapActions("sSysLogin", {
      CLEAR_SYS_LOGIN: "CLEAR_SYS_LOGIN"
    }),
    ...mapActions("sAgtLogin", {
      CLEAR_AGT_LOGIN: "CLEAR_AGT_LOGIN"
    }),
    // ...mapActions('sDashBoard',{
    //     SET_AGENT_LOGO_DET_REQUEST:'SET_AGENT_LOGO_DET_REQUEST',
    //     SET_AGENT_LOGO_DET_RESPONSE:'SET_AGENT_LOGO_DET_RESPONSE',
    //    // SET_AGENT_FINANCE_RESPONSE:'SET_AGENT_FINANCE_RESPONSE'
    //     }),

    navigateIfMbl(){
      if(BaseConfiguration.isMobile){
        navigate(PATHNAME.APROFILE);
      }
    },

    viewBalance(val) {
      alert(JSON.stringify(val));
    },

    showAlert(val) {
      this.alertValue = val;
    },

    toggleShowLoginInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleShowLoginInfo");
        //let retValue;
        this.isShowLoginInfo = !this.isShowLoginInfo;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in toggleShowLoginInfo",
          err.toString(),
          "toggleShowLoginInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      //return retValue;
    },
    onLogout() {
      try {
         removeB2BMFfromSession();

        clearStore();
        apiLogOut.getLogout();
        // this.CLEAR_AGT_LOGIN();
        // this.CLEAR_SYS_LOGIN();
        if (store.getters["sSysLogin/GET_ADMIN_SIGNIN_RES"]) {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.SYSTEM_LOGIN);
        } else if (store.getters["sAgtLogin/GET_SIGNIN_RES"]) {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.AGENT_LOGIN);
        } else {
          this.CLEAR_AGT_LOGIN();
          this.CLEAR_SYS_LOGIN();
          navigate(PATHNAME.AGENT_LOGIN);
        }
       


      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in onLogout",
          err.toString(),
          "onLogout",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }

    // async getUserLogoDet() {
    //     let returnValue;
    //     try {
    //         let userLogoReq = apiUserLogoDet.buildRequest();
    //         if (userLogoReq != null) {

    //             this.SET_AGENT_LOGO_DET_REQUEST(userLogoReq)
    //             let userLogoRes = await apiUserLogoDet.getResponse(userLogoReq);
    //             if (VALIDATE_SUCCESS_RES(userLogoRes)) {
    //                 returnValue = userLogoRes.data.data;
    //                 this.SET_AGENT_LOGO_DET_RESPONSE(returnValue)
    //             } else {
    //                 let error = getErrorMessage(userLogoRes);
    //                 let isJwt = handleJWT(error);
    //                 if (!isJwt) {
    //                     this.showAlert(getErrorAlertValue(error));
    //                 } else {
    //                     returnValue = [];
    //                 }
    //             }
    //         } else {
    //             throw "invalid request";
    //         }
    //     } catch (err) {
    //         let body = Logger.buildRequest(
    //             FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //             "error in  getting UserLogo Details",
    //             err.toString(),
    //             " getUserLogoDet()",
    //             LOG_TYPE.ERROR
    //         );
    //         Logger.getResponse(body);
    //     }
    //     return returnValue;
    // },

    //  async getBalanceDetail() {
    //     let returnValue;
    //     try {
    //         let balanceReq = apiGetBalanceDetail.buildRequest();
    //         if (balanceReq) {
    //             let balanceRes = await apiGetBalanceDetail.getResponse(balanceReq);
    //             if (VALIDATE_SUCCESS_RES(balanceRes)) {
    //                 returnValue = balanceRes.data.data;
    //                 this.SET_AGENT_FINANCE_RESPONSE(returnValue)
    //             } else {
    //                 let error = getErrorMessage(balanceRes);
    //                 let isJwt = handleJWT(error);
    //                 if (!isJwt) {
    //                     this.showAlert(getErrorAlertValue(error));
    //                 } else {
    //                     returnValue = [];
    //                 }
    //             }
    //         } else {
    //             throw "invalid request";
    //         }
    //     } catch (err) {
    //         let body = Logger.buildRequest(
    //             FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //             "error in  getBalanceDetail",
    //             err.toString(),
    //             " getBalanceDetail()",
    //             LOG_TYPE.ERROR
    //         );
    //         Logger.getResponse(body);
    //     }
    //     return returnValue;
    // },

    // getProgressPercent(finance,isPrepaid) {
    //     try {
    //       if(BaseConfiguration.isDebug) console.log("getProgressPercent");
    //       let retValue;
    //       if(isPrepaid){
    //            retValue = (parseFloat(finance.prepaidbalance)/parseFloat(finance.prepaidbalance))*100;
    //       }else{
    //            retValue = (parseFloat(finance.postpaid_runningamount)/parseFloat(finance.postpaidlimit))*100;
    //       }
    //      // console.log(retValue)
    //       return retValue;
    //     } catch (err) {
    //             let body = Logger.buildRequest(
    //               FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //               "error in getProgressPercent",
    //               err.toString(),
    //               "getProgressPercent",
    //               LOG_TYPE.ERROR
    //             );
    //             Logger.getResponse(body);
    //           }
    //       //return retValue;
    //     },

    // async getLogoDetail() {
    //     try {
    //       if(BaseConfiguration.isDebug) console.log("getLogoDetail");
    //      // let retValue;
    //       this.userLogoDet.logoDet = await this.getUserLogoDet();
    //       this.userLogoDet.b2bCompanyFinancess = await this.getBalanceDetail();
    //     } catch (err) {
    //             let body = Logger.buildRequest(
    //               FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
    //               "error in getLogoDetail",
    //               err.toString(),
    //               "getLogoDetail",
    //               LOG_TYPE.ERROR
    //             );
    //             Logger.getResponse(body);
    //           }
    //     //  return retValue;
    //     },
  },

  async created() {
    if (BaseConfiguration.isDebug) console.log("created");
    let logoDetail = null;
    if (this.userLogoDetail) logoDetail = this.userLogoDetail;
    //logoDetail.roles.push('hello')
    if (logoDetail) this.userLogoDet.logoDet = logoDetail;
  },

  computed: {
    currentRouteName() {
        return this.$route.name;
    },
    getUserName: function() {
      let retValue;
      try {
        if (
          this.userLogoDet.logoDet &&
          this.userLogoDet.logoDet.firstname &&
          this.userLogoDet.logoDet.lastname
        ) {
          retValue =
            this.userLogoDet.logoDet.firstname +
            " " +
            this.userLogoDet.logoDet.lastname;
        } else if (
          this.userLogoDet.logoDet &&
          this.userLogoDet.logoDet.firstname
        ) {
          retValue = this.userLogoDet.logoDet.firstname;
        } else {
          retValue = "";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.THE_HEADER_DROPDOWN_ACCNT,
          "error in getting user name",
          err.toString(),
          "getUserName()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    ...mapGetters("sSysLogin", {
      GET_ADMIN_SIGNIN_REQ: "GET_ADMIN_SIGNIN_REQ",
      GET_ADMIN_SIGNIN_RES: "GET_ADMIN_SIGNIN_RES"
    }),
    ...mapGetters("sDashBoard", {
      userLogoDetail: "GET_AGENT_LOGO_DET_RES"
    })
  }
};
</script>

<style scoped>
.round {
  border-radius: 50%;
}

.c-icon {
  margin-right: 0.3rem;
}
</style>
